import React, { useEffect } from "react";
import { Formik, Field } from "formik";
import {
  CsplTable as Table,
  DatePicker,
  FieldDropSide,
  Link,
  MultiSelectDropdown,
} from "../../../components";
import {
  usDateFormat,
  MANAGE_RKAAS_ROUTES,
  getTwoDecimalPlaces,
} from "../../../utils";
import { getTrailBalance } from "../../../services";
import { Button, Form } from "react-bootstrap";
const columns = [
  {
    label: "Particulars",
    className: "column-planName col-md-3",
    columnName: "particulars",
  },
  {
    label: "Opening balance",
    className: "column-status col-md-3",
    columnName: "openingBalance",
  },
  {
    label: "Transactions for the period",
    className: "column-status col-md-3",
    columnName: "transactionsForPeriod",
  },
  {
    label: "Closing balance",
    className: "column-status col-md-3",
    columnName: "closingBalance",
  },
];
const data = [
  {
    particulars: "sponsor employer recievable amount",
    openingBalance: 340123,
    transactionsForPeriod: 102123,
    closingBalance: 442246,
  },
  {
    particulars: "sponsor employer recievable amount",
    openingBalance: 340123,
    transactionsForPeriod: 102123,
    closingBalance: 442246,
  },
  {
    particulars: "sponsor employer recievable amount",
    openingBalance: 340123,
    transactionsForPeriod: 102123,
    closingBalance: 442246,
  },
  {
    particulars: "sponsor employer recievable amount",
    openingBalance: 340123,
    transactionsForPeriod: 102123,
    closingBalance: 442246,
  },
  {
    particulars: "sponsor employer recievable amount",
    openingBalance: 340123,
    transactionsForPeriod: 102123,
    closingBalance: 442246,
  },
  {
    particulars: "sponsor employer recievable amount",
    openingBalance: 340123,
    transactionsForPeriod: 102123,
    closingBalance: 442246,
  },
  {
    particulars: "sponsor employer recievable amount",
    openingBalance: 340123,
    transactionsForPeriod: 102123,
    closingBalance: 442246,
  },
  {
    particulars: "sponsor employer recievable amount",
    openingBalance: 340123,
    transactionsForPeriod: 102123,
    closingBalance: 442246,
  },
  {
    particulars: "sponsor employer recievable amount",
    openingBalance: 340123,
    transactionsForPeriod: 102123,
    closingBalance: 442246,
  },
];
const total = {
  particulars: "Total",
  openingBalance: 0,
  transactionsForPeriod: 0,
  closingBalance: 0,
};
const fields = {
  startDate: "startDate",
  endDate: "endDate",
};

const TrailBalance = (props) => {
  const payload = {
    planId: 0,
    fromDate: "2022-12-08T13:08:04.366Z",
    toDate: "2022-12-08T13:08:04.366Z",
  };
  useEffect(() => {
    getTrailBalance(payload)
      .then((res) => {
        if (res) {
        }
      })
      .catch((err) => err);
  }, []);
  const onFormSubmit = () => {};
  return (
    <div>
      <Formik initialValues={{}} onSubmit={onFormSubmit} enableReinitialize>
        {({ handleChange, setFieldValue, handleSubmit, values, ...rest }) => {
          const onDaySelected = (fieldName, value) => {
            setFieldValue(fieldName, value);
          };
          return (
            <Form autoComplete="off" className="h-100" onSubmit={handleSubmit}>
              <div className="d-flex" style={{ alignItems: "center" }}>
                <div className="ml-3">
                  <Button
                    type="button"
                    className="add-btn"
                    variant="secondary"
                    style={{
                      height: "fit-content",
                      fontSize: "0.75rem",
                      marginTop: "10%",
                    }}
                  >
                    This month
                  </Button>
                </div>
                <div className="ml-3">
                  <Button
                    type="button"
                    className="add-btn"
                    variant="secondary"
                    style={{
                      height: "fit-content",
                      fontSize: "0.75rem",
                      marginTop: "10%",
                    }}
                  >
                    Last month
                  </Button>
                </div>
                <div className="ml-3">
                  <Field
                    size="smd"
                    label="Start Date"
                    name={fields.startDate}
                    value={usDateFormat(values[fields.startDate])}
                    isDatePicker
                    onClear={() => onDaySelected(fields.startDate, null)}
                    popupContent={
                      <DatePicker
                        onDayClick={(value) =>
                          onDaySelected(fields.startDate, value)
                        }
                        value={usDateFormat(values[fields.payDate])}
                      />
                    }
                    component={FieldDropSide}
                  />
                </div>
                <div className="ml-3">
                  <Field
                    size="smd"
                    label="End Date"
                    name={fields.endDate}
                    value={usDateFormat(values[fields.endDate])}
                    isDatePicker
                    onClear={() => onDaySelected(fields.endDate, null)}
                    popupContent={
                      <DatePicker
                        onDayClick={(value) =>
                          onDaySelected(fields.endDate, value)
                        }
                        value={usDateFormat(values[fields.endDate])}
                      />
                    }
                    component={FieldDropSide}
                  />
                </div>
              </div>
            </Form>
          );
        }}
      </Formik>
      <Table>
        <Table.Thead>
          <Table.Tr>
            {columns.map((item, index) => {
              return (
                <Table.Th key={index} className={item.className}>
                  {item.label}
                </Table.Th>
              );
            })}
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {data.map((e, i) => {
            return (
              <Table.Tr key={i}>
                {columns.map((item, cellIndex) => {
                  const getContent = () => {
                    if (item.columnName === "particulars") {
                      return (
                        <Link to={MANAGE_RKAAS_ROUTES.LEDGERS}>
                          {e[item.columnName]}
                        </Link>
                      );
                    }
                    return `$ ${getTwoDecimalPlaces(e[item.columnName])}`;
                  };
                  return (
                    <Table.Td key={cellIndex} className={item.className}>
                      {getContent()}
                    </Table.Td>
                  );
                })}
              </Table.Tr>
            );
          })}
          <Table.Tr>
            {columns.map((e, i) => {
              const getContent = () => {
                if (e.columnName === "particulars") {
                  return total[e.columnName];
                }
                return `$ ${getTwoDecimalPlaces(total[e.columnName])}`;
              };
              return (
                <Table.Th
                  key={i}
                  className={`${e.className} table-total-value`}
                >
                  {getContent()}
                </Table.Th>
              );
            })}
          </Table.Tr>
        </Table.Tbody>
      </Table>
    </div>
  );
};
export default TrailBalance;
